<template>
  <div class="mb-5">
    <div class="mb-1 flex items-center">
      <div class="font-medium text-[13px] leading-[18px] text-gray-800 mr-1.5">
        {{ label }}
      </div>

      <Tooltip v-if="isOwner" size="lg" :content="tooltip">
        <span
          class="pointer-events-none tablet-v:pointer-events-auto cursor-pointer"
          @click="$emit('infoClick')"
        >
          <InfoSmallIcon class="size-[12px] opacity-50" />
        </span>
      </Tooltip>
    </div>

    <div v-if="entities.length" class="mb-1.5 flex flex-col gap-y-1">
      <div
        v-for="entity in entities.slice(0, MAX_VISIBLE)"
        :key="entity.id"
        class="leading-[18px] text-gray-800 flex items-center"
      >
        {{ entity.name }}
      </div>

      <div
        v-if="entities.length > MAX_VISIBLE"
        class="flex items-center font-medium text-gray-500 cursor-pointer gap-x-1.5"
        @click="$emit('moreClick')"
      >
        <div>+{{ entities.length - MAX_VISIBLE }} more</div>
        <ChevronDownIcon class="size-[14px] text-gray-500" />
      </div>
    </div>

    <div v-else-if="showEmpty">—</div>

    <div
      v-if="isOwner && addLabel"
      class="w-fit text-[14px] leading-[22px] text-link"
      @click="$emit('addClick')"
    >
      {{ addLabel }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { Tooltip } from '@dacr/library'
import { InfoSmallIcon, ChevronDownIcon } from '@dacr/icons'

const MAX_VISIBLE = 3

defineProps<{
  label: string
  entities: { id: string; name: string }[]
  isOwner: boolean
  tooltip: string
  addLabel?: string
  showEmpty?: boolean
}>()

defineEmits<{
  infoClick: []
  addClick: []
  moreClick: []
}>()
</script>
